/**
 * Created by jonas on 2021-02-02.
 */
import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {IBetClusterWin, IComboWinData, TheBorderGameData, TheBorderInitData} from "./server/TheBorderData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {TheBorder} from "./TheBorder";
import {TheBorderGameMode} from "./server/TheBorderGameMode";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {ISymbol} from "../core/reel/ReelInterfaces";
import {TheBorderStatics} from "./TheBorderStatics";
import {TheBorderScatterSymbol} from "./reels/TheBorderScatterSymbol";
import {TheBorderSymbol} from "./reels/TheBorderSymbol";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class TheBorderModel extends GameModel<TheBorderInitData, TheBorderGameData> {
    public nearWinReels:boolean[] = [false, false, false, false, false, false];
    private _isLuckyDraw:boolean = false;
    private _allXWaysRelatedPositions:string[] = [];
    private _accumulatedRoundWin:number;
    private _previousAccumulatedRoundWin:number;
    private _scatterOnReelOnFSTriggered:boolean[] = [false, false, false, false, false, false];
    private _isRestore:boolean = false;
    private _isRestoreForNearWin:boolean = false;
    private _avalancheCollapseComplete:boolean = false;
    private _freespinsLeft:number;
    private _winRatio:number;
    private _allWinPositions:boolean[][];
    private _xWayPositions:PIXI.Point[];
    private _xWay:boolean;
    private _evaluatedArea:string[][];
    private _currentMultiplier:number;
    private _betClusterWins:IBetClusterWin[];
    private _allWinClusters:PIXI.Point[][];
    private _comboWinData:IComboWinData[];
    private _reels:string[][];
    private _symbolYPositionsEvaluatedArea:number[][];
    private _size4xWay:boolean;
    private _bonusLevel:number;
    private _allSize:number[][];
    private _nextPlayerInteraction:any;
    private _enhancedBet:boolean;
    private _xWayTransformSymbol:string;
    private _brokeBank:boolean;
    private _explodePositions:boolean[][];
    private _reelsEnteringFreespin:string[][];
    private _playedBetValue:number;
    private _thisSpinWinnings:number;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);

        api.events.once("featureName", (data:string) => this.onFeatureName(data));
        api.events.on(APIEvent.BET, (betData:APIFeatureBetEventData) => this.onBet(betData));
        api.events.on(APIEvent.ACTION_SPINS_BET, (betData:APIFeatureBetEventData) => this.onBet(betData));
    }

    private onFeatureName(name:string):void{
        TheBorder.buyFeatureName = name;
    }

    public onGame(data:TheBorderGameData):void {
        if (TheBorder.isActionSpinsActive) {
            return;
        }
        TheBorderModel.parseReels(data.reels);
        super.onGame(data);
        this._thisSpinWinnings = data.thisSpinWinnings;
        this._playedBetValue = data.playedBetValue;
        this._isRestore = false;
        this._allWinClusters = [];
        this._size4xWay = data.size4xWay;
        this._reels = data.reels;
        this._betClusterWins = data.betClusterWins;
        this._currentMultiplier = data.currentMultiplier;
        this._evaluatedArea = data.evaluatedArea;
        this._symbolYPositionsEvaluatedArea = TheBorderModel.parseSymbolPositions(data.reels);
        this._freespinsLeft = data.freespinsLeft;
        this._allWinPositions = data.allWinPositions;
        this._previousAccumulatedRoundWin = this._accumulatedRoundWin;
        this._accumulatedRoundWin = data.accumulatedRoundWin;
        this._xWayPositions = this.parseXWayPositions(data.reels);
        this._totalSpinRoundWinnings = data.totalSpinRoundWinnings;
        if(TheBorder.model.data.mode == TheBorderGameMode.NORMAL || TheBorder.model.data.mode == TheBorderGameMode.NORMAL_AVALANCHE) {
            this._winRatio = MathHelper.ceilToDecimals((data.accumulatedRoundWin / data.playedBetValue), 2);
        } else {
            this._winRatio = MathHelper.ceilToDecimals((this._totalSpinRoundWinnings / data.playedBetValue), 2);
        }
        this._comboWinData = this.parseComboWinData(data);
        this._bonusLevel = data.bonusLevel;
        this._xWayTransformSymbol = data.xWayTransformSymbol;
        this._brokeBank = data.brokeBank;
        this._explodePositions = data.explodePositions;
        if(data.freespinTriggeredThisSpin) {
            data.reelsEnteringFreespin?.forEach((reels:string[], reelId:number) => {
                this._scatterOnReelOnFSTriggered[reelId] = (reels.indexOf("BN") > -1 || reels.indexOf("BN_H") > -1);
            });
        }

        if((data.mode === TheBorderGameMode.NORMAL_AVALANCHE) || (data.mode === TheBorderGameMode.NORMAL && (this._isLuckyDraw || !data.wasFeatureBuy))) {
            this.nearWinReels = this.checkForNearWin(this._reels);
        }
        this._isRestoreForNearWin = false;
    }

    protected onInit(data:TheBorderInitData):void {
        TheBorderModel.parseReels(data.reels);
        super.onInit(data);
        this._reelsEnteringFreespin = data.reelsEnteringFreespin;
        this._allSize = data.allSize;
        this._reels = data.reels;
        this._isRestoreForNearWin = data.isRestoreState;
        this._isRestore = data.isRestoreState;
        if(this._isRestore) {
            if(this._reelsEnteringFreespin) {
                this._symbolYPositionsEvaluatedArea = TheBorderModel.parseSymbolPositions(data.reelsEnteringFreespin);
            } else {
                this._symbolYPositionsEvaluatedArea = TheBorderModel.parseSymbolPositions(data.reelsAfterCollapse);
            }
        } else {
            this._symbolYPositionsEvaluatedArea = TheBorderModel.parseSymbolPositions(data.reels);
        }
        this._freespinsLeft = data.freespinsLeft;
        this._accumulatedRoundWin = data.accumulatedRoundWin;
        this._previousAccumulatedRoundWin = this._accumulatedRoundWin;
        this._currentMultiplier = data.currentMultiplier;
        this._reels = data.reels;
        if(this._isRestore && (TheBorder.model.data.nextMode == TheBorderGameMode.FREESPIN_AVALANCHE
            || TheBorder.model.data.nextMode == TheBorderGameMode.NORMAL_AVALANCHE
            || TheBorder.model.data.nextMode == TheBorderGameMode.SUPER_FREESPIN_AVALANCHE)) {
            this._avalancheCollapseComplete = true;
        }
        this._bonusLevel = data.bonusLevel;
        this._nextPlayerInteraction = data.nextPlayerInteraction;
        this._enhancedBet = data.enhancedBet;

        if(this._isRestore && data.mode.indexOf("FREESPIN") > -1) {
            TheBorder.isInFS = true;
            data.reelsEnteringFreespin?.forEach((reels:string[], reelId:number) => {
                this._scatterOnReelOnFSTriggered[reelId] = (reels.indexOf("BN") > -1 || reels.indexOf("BN_H") > -1);
            });
        }
        data.reelsEnteringFreespin?.forEach((reels:string[], reelId:number) => {
            this._scatterOnReelOnFSTriggered[reelId] = (reels.indexOf("BN") > -1 || reels.indexOf("BN_H") > -1);
        });
    }

    public static hasBeenChecked(reel:number, row:number, positions:PIXI.Point[][]):boolean {
        for(let i:number = 0; i < positions.length; i++) {
            for(let j:number = 0; j < positions[i].length; j++) {
                if(positions[i][j].x === reel && positions[i][j].y === row) {
                    return true;
                }
            }
        }
        return false;
    }

    //Goes through all the symbols and returns an array with the symbol Y position
    private static parseSymbolPositions(reels:string[][]):number[][] {
        const positions:number[][] = [];
        for(let i:number = 0; i < reels.length; i++) {
            const reel:number[] = [];
            let counter:number = 0;
            for(let j:number = 0; j < reels[i].length; j++) {
                if(j == 0) {
                    reel.push(counter);
                } else {
                    if(reels[i][j - 1].indexOf("_H") > -1) {
                        counter += 50;
                        reel.push(counter);
                    } else {
                        counter += 100;
                        reel.push(counter);
                    }
                }
            }
            positions.push(reel);
        }
        return positions;
    }

    private static getTopLeftPosition(winSymbolPositions:boolean[][], evaluatedArea:string[][]):PIXI.Point {
        for(let i:number = 0; i < winSymbolPositions.length; i++) {
            let k:number = 0;

            for(let j:number = 0; j < winSymbolPositions[i].length;) {
                if(winSymbolPositions[i][j]) {
                    if(TheBorder.wildSymbolNames.indexOf(evaluatedArea[i][k]) === -1) {
                        return new PIXI.Point(i, k);
                    }
                }
                if(evaluatedArea[i][k].indexOf("_H") > -1) {
                    j++;
                } else {
                    j += 2;
                }
                k++;
            }
        }

        return new PIXI.Point(0, 0);
    }

    private static parseReels(reels:string[][]):string[][] {
        for(let i:number = 0; i < reels.length; i++) {
            for(let j:number = 0; j < reels[i].length; j++) {
                if(reels[i][j] == "X_SPLIT_Spent") {
                    reels[i][j] = "X_SPLIT_SPENT";
                }
            }
        }
        return reels;
    }

    public getAllWinPos(clusterWinData?:PIXI.Point[]):Map<number, number[]> {
        let allWinPosMap:Map<number, number[]> = new Map<number, number[]>();
        if(clusterWinData) {
            clusterWinData.forEach((point:PIXI.Point) => {
                if(!allWinPosMap.has(point.x)) {
                    allWinPosMap.set(point.x, []);
                }
                allWinPosMap.get(point.x)?.push(point.y);
            });
        } else {
            TheBorder.model.allWinPositions.forEach((reels:boolean[], reelId:number) => {
                reels.forEach((isWinSym:boolean, rowID:number) => {
                    if(isWinSym) {
                        if(!allWinPosMap.has(reelId)) {
                            allWinPosMap.set(reelId, []);
                        }
                        allWinPosMap.get(reelId)?.push(rowID);
                    }
                });
            });
        }
        return allWinPosMap;
    }

    private _totalSpinRoundWinnings:number;

    private onBet(betData:APIFeatureBetEventData):void {
        this._isLuckyDraw = (betData.featureName === "LUCKY_DRAW");

        for(let index:number = 0; index < TheBorder.model.initData.featureBuyTimesBetValue.length; index++) {
            if(TheBorder.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                TheBorder.buyFeatureName = betData.featureName;
                break;
            }
        }
        if(betData.type == "normalBet") {
            if(TheBorder.buyFeatureName == "BOOSTED_BET") {
                TheBorder.buyFeatureName = "";
            }
        }
    }

    private parseComboWinData(data:TheBorderGameData):IComboWinData[] {
        const comboWinData:IComboWinData[] = [];
        for(let i:number = 0; i < this._betClusterWins.length; i++) {
            comboWinData.push({
                amount : this._betClusterWins[i].multipliedAmount,
                reelPosition : TheBorderModel.getTopLeftPosition(this._betClusterWins[i].reelWinPositions, data.evaluatedArea)
            });
        }
        return comboWinData;
    }

    private parseAllWinClusters(allWinPositions:boolean[][]):PIXI.Point[][] {
        const allWinClusters:PIXI.Point[][] = [];
        let subWinCluster:PIXI.Point[] = [];
        for(let i:number = 0; i < allWinPositions.length; i++) {
            for(let j:number = 0; j < allWinPositions[i].length; j++) {
                if(allWinPositions[i][j] && !TheBorderModel.hasBeenChecked(i, j, allWinClusters)) {
                    subWinCluster = [];
                    subWinCluster.push(new PIXI.Point(i, j));

                    //1. Are there any connected win below?
                    //Don't do if its bottom symbol
                    if((j + 1) < allWinPositions[i].length) {
                        for(let k:number = j + 1; k < allWinPositions[i].length; k++) {
                            if(allWinPositions[i][k]) {
                                subWinCluster.push(new PIXI.Point(i, k));
                            } else {
                                break;
                            }
                        }
                    }

                    //2. Check to the right of all wins, if any add that and all connected up and down.
                    if(i < 5) {
                        let reelToCheck = i + 1;
                        subWinCluster = this.checkConnectedWin(reelToCheck, subWinCluster);
                    }
                    allWinClusters.push(subWinCluster);
                }
            }
        }
        return allWinClusters;
    }

    private checkForConnectedWinRightOfSymbol(symbol:ISymbol):PIXI.Point {
        let reelToTheRight:ISymbol[] = TheBorder.allReelsView.mainReelModels[symbol.reelId + 1].getAllSymbols();
        let returnSymbolPosition:PIXI.Point = new PIXI.Point(-1, -1);
        for(let i:number = 0; i < reelToTheRight.length; i++) {
            //If symbol to the right is on the same YPos it's a connect
            if((reelToTheRight[i].position.y == symbol.position.y) && (this._allWinPositions[reelToTheRight[i].reelId][reelToTheRight[i].reelPosition - 1])) {
                returnSymbolPosition.x = reelToTheRight[i].reelId;
                returnSymbolPosition.y = reelToTheRight[i].reelPosition - 1;
                return returnSymbolPosition;
            }
            //If full symbol and connect with half or full symbol on lower part
            if(symbol.position.y == reelToTheRight[i].position.y + (TheBorderStatics.symbolHeight / 2) && (this._allWinPositions[reelToTheRight[i].reelId][reelToTheRight[i].reelPosition - 1])) {
                returnSymbolPosition.x = reelToTheRight[i].reelId;
                returnSymbolPosition.y = reelToTheRight[i].reelPosition - 1;
                return returnSymbolPosition;
            }
            //If full och half symbol connected with full symbol offset up
            if(symbol.position.y == reelToTheRight[i].position.y - (TheBorderStatics.symbolHeight / 2) && (this._allWinPositions[reelToTheRight[i].reelId][reelToTheRight[i].reelPosition - 1])) {
                returnSymbolPosition.x = reelToTheRight[i].reelId;
                returnSymbolPosition.y = reelToTheRight[i].reelPosition - 1;
                return returnSymbolPosition;
            }
        }
        return returnSymbolPosition;
    }

    private checkConnectedWin(reelToCheck:number, clusterBuild:PIXI.Point[]):PIXI.Point[] {
        let reel:number;
        let row:number;
        let addedClusterWinPositions:PIXI.Point[] = [];
        let checkedReel:number = -1;
        const uniqueCheckArray:string[] = [];
        for(let i:number = 0; i < clusterBuild.length; i++) {
            reel = clusterBuild[i].x + 1;
            row = clusterBuild[i].y;
            uniqueCheckArray.push(clusterBuild[i].x + "" + clusterBuild[i].y);
            //Is there a connected win symbol to the right of current win symbol?
            let connectedSymbolPosition:PIXI.Point = this.checkForConnectedWinRightOfSymbol(TheBorder.allReelsView.mainReelModels[reel - 1].getSymbol(row));
            if(connectedSymbolPosition.x > -1 && reel == reelToCheck && reelToCheck >= checkedReel) {
                //Move one step to the right and check up and down for connecting wins
                checkedReel = reel;
                if(uniqueCheckArray.indexOf(reel + "" + connectedSymbolPosition.y) == -1) {
                    addedClusterWinPositions.push(new PIXI.Point(reel, connectedSymbolPosition.y));
                    uniqueCheckArray.push(reel + "" + connectedSymbolPosition.y);
                }

                //Check down
                if((connectedSymbolPosition.y + 1) < this._allWinPositions[reel].length) {
                    for(let j:number = connectedSymbolPosition.y + 1; j < this._allWinPositions[reel].length; j++) {
                        if(this._allWinPositions[reel][j]) {
                            if(uniqueCheckArray.indexOf(reel + "" + j) == -1) {
                                addedClusterWinPositions.push(new PIXI.Point(reel, j));
                                uniqueCheckArray.push(reel + "" + j);
                            }

                        } else {
                            break;
                        }
                    }
                }
                //Check up
                if((connectedSymbolPosition.y - 1) > -1) {
                    for(let j:number = connectedSymbolPosition.y - 1; j > -1; j--) {
                        if(this._allWinPositions[reel][j]) {
                            if(uniqueCheckArray.indexOf(reel + "" + j) == -1) {
                                addedClusterWinPositions.push(new PIXI.Point(reel, j));
                                uniqueCheckArray.push(reel + "" + j);
                            }
                        } else {
                            break;
                        }
                    }
                }
            }
        }
        if(addedClusterWinPositions.length > 0) {
            for(let i:number = 0; i < addedClusterWinPositions.length; i++) {
                clusterBuild.push(addedClusterWinPositions[i]);
            }
            if((reelToCheck + 1) < 6) {
                this.checkConnectedWin((reelToCheck + 1), clusterBuild);
            }
        }

        return clusterBuild;
    }

    private parseXWayPositions(reels:string[][]):PIXI.Point[] {
        const xWayPositions:PIXI.Point[] = [];
        this._xWay = false;
        for(let i:number = 0; i < reels.length; i++) {
            for(let j:number = 0; j < reels[i].length; j++) {
                if(reels[i][j] == "X_WAYS") {
                    this._xWay = true;
                    xWayPositions.push(new PIXI.Point(i, j));
                }
            }
        }
        return xWayPositions;
    }

    private checkForNearWin(reels:string[][]):boolean[] {
        let scatterCount:number = 0;
        const scatters: number[][] = [],
            allScatterSymbols:TheBorderScatterSymbol[] = TheBorder.scatterSymbols.getAllUsedSymbols(),
            yPosSymbols: number[][] = this._symbolYPositionsEvaluatedArea,
            retValAllFalse:boolean[] = [false, false, false, false, false, false],
            retVal:boolean[] = retValAllFalse.concat(),
            previousScatterReelIds:boolean[] = retValAllFalse.concat();

        allScatterSymbols.forEach((sym:TheBorderScatterSymbol) => {
            scatterCount += sym.splitLevel;

            previousScatterReelIds[sym.reelId] = true;
        });

        if (this.gameData.mode === TheBorderGameMode.NORMAL_AVALANCHE) {
            for (let reel:number = 0; reel < reels.length; reel++) {
                scatters[reel] = [];
                let symbols: TheBorderSymbol[] = (TheBorder.allReelsView.mainReelModels[reel].reelView.getAllSymbols() as TheBorderSymbol[]);
                if (this._isRestoreForNearWin) {
                    symbols = (TheBorder.allReelsView.mainReelModels[reel].reelView.collapsedReel as TheBorderSymbol[]);
                }
                for (let row: number = 0; row < symbols.length; row++) {
                    if (symbols[row].symbolName.indexOf("BN") > -1) {
                        const scatterRow: number = yPosSymbols[reel].indexOf(symbols[row].y);
                        if (scatterRow > -1) {
                            scatters[reel][scatterRow] = symbols[row].splitLevel;
                        }
                    }
                }
            }
        }

        // if anticipation ran on 1st reel, due to previous scatters.
        retVal[0] = this.nearWinReels[0];

        for (let reel:number = 0; reel < reels.length; reel++) {
            scatters[reel] = scatters[reel] || [];
            for(let rowId:number = 0; rowId < reels[reel].length; rowId++) {
                if(reels[reel][rowId].indexOf("BN") > -1) {
                    if(reels[reel][rowId].indexOf("X_WAYS") > -1) {
                        return retValAllFalse;
                    }

                    if (!previousScatterReelIds[reel]) {
                        scatterCount++;

                        scatters[reel][rowId] = 1;
                    }
                }

                if(reels[reel][rowId] === "X_SPLIT" || reels[reel][rowId] === "X_SPLIT_H") {
                    if(reels[reel][rowId].indexOf("X_WAYS") > -1) {
                        return retValAllFalse;
                    }

                    const symbolsToLeft:number[][] = this.getSymbolsClosestToYPos(reels, reel, rowId);
                    for(let i:number = 0; i < symbolsToLeft.length; i++) {
                        let splitLevel:number = scatters[symbolsToLeft[i][0]][symbolsToLeft[i][1]];

                        scatterCount -= splitLevel;
                        splitLevel *= 2;
                        scatterCount += splitLevel;

                        scatters[symbolsToLeft[i][0]][symbolsToLeft[i][1]] = splitLevel;
                    }
                }
            }

            if(scatterCount > 4) {
                for(let i:number = (reel + 1); i < reels.length; i++) {
                    // if in next reel, there is scatter already from previous result OR there is no symbol to fall
                    if((TheBorder.model.gameData.mode === TheBorderGameMode.NORMAL_AVALANCHE) && (previousScatterReelIds[i] || (reels[i].length === TheBorder.allReelsView.getReelLength(i)))) {
                        retVal[i] = false;
                        continue;
                    }

                    retVal[i] = true;
                }

                return retVal;
            }
        }

        return retVal;
    }

    private getSymbolsClosestToYPos(reels:string[][], xSplitReelId:number, xSplitRowId:number):number[][] {
        const reelPosition:number[][] = [],
            yPosSymbols:number[][] = this._symbolYPositionsEvaluatedArea,
            xSplitYPos:number = yPosSymbols[xSplitReelId][xSplitRowId],
            range:number = this.getHeightOfSymbol(xSplitReelId, xSplitRowId);

        for(let reel:number = (xSplitReelId - 1); reel > -1; reel--) {
            for(let row:number = 0; row < yPosSymbols[reel].length; row++) {
                //Symbol on same YPos found (reel is not offset)
                if(yPosSymbols[reel][row] === xSplitYPos && reels[reel][row].indexOf("BN") > -1) {
                    reelPosition.push([reel, row]);
                    //Symbol found is half but range is full symbol
                    if(yPosSymbols[reel][row + 1] && this.getHeightOfSymbol(reel, row) === 50 && range === 100 && reels[reel][row + 1].indexOf("BN") > -1) {
                        reelPosition.push([reel, row + 1]);
                    }
                }
            }

            //No symbols found on same yPos. Reel is offset.
            if(reelPosition.length === 0 && range === 100) {
                for(let row:number = 0; row < yPosSymbols[reel].length; row++) {
                    //Looking for symbol, half symbol offset up
                    if(yPosSymbols[reel][row] === xSplitYPos - 50 && reels[reel][row].indexOf("BN") > -1) {
                        reelPosition.push([reel, row]);
                        if(yPosSymbols[reel][row + 1] && reels[reel][row + 1].indexOf("BN") > -1) {
                            reelPosition.push([reel, row + 1]);
                        }
                    }
                }
            }

            //No symbols found on same yPos. Reel is offset. for half symbol
            if(reelPosition.length === 0 && range === 50) {
                for(let row:number = 0; row < yPosSymbols[reel].length; row++) {
                    //Looking for symbol, half symbol offset up
                    if(yPosSymbols[reel][row] === xSplitYPos - 50 && reels[reel][row].indexOf("BN") > -1) {
                        reelPosition.push([reel, row]);
                    }
                }
            }
        }

        return reelPosition;
    }

    private getHeightOfSymbol(reel:number, row:number):number {
        const yPosSymbols:number[] = this._symbolYPositionsEvaluatedArea[reel];

        if((yPosSymbols.length - 1) === row) {
            let sum = 0;
            for(let i = 0; i < yPosSymbols.length - 2; i++) {
                sum += yPosSymbols[i];
            }
            return (600 - sum);
        } else {
            return (yPosSymbols[row + 1] - yPosSymbols[row]);
        }
    }

    get isRestoreForNearWin(): boolean {
        return this._isRestoreForNearWin;
    }

    get totalSpinRoundWinnings():number {
        return this._totalSpinRoundWinnings;
    }

    get isLuckyDraw():boolean {
        return this._isLuckyDraw;
    }

    get allXWaysRelatedPositions():string[] {
        return this._allXWaysRelatedPositions;
    }

    set allXWaysRelatedPositions(value:string[]) {
        this._allXWaysRelatedPositions = value;
    }

    get accumulatedRoundWin():number {
        return this._accumulatedRoundWin;
    }

    get previousAccumulatedRoundWin():number {
        return this._previousAccumulatedRoundWin;
    }

    get scatterOnReelOnFSTriggered():boolean[] {
        return this._scatterOnReelOnFSTriggered;
    }

    get isRestore():boolean {
        return this._isRestore;
    }

    get avalancheCollapseComplete():boolean {
        return this._avalancheCollapseComplete;
    }

    set avalancheCollapseComplete(value:boolean) {
        this._avalancheCollapseComplete = value;
    }

    get freespinsLeft():number {
        return this._freespinsLeft;
    }

    set freespinsLeft(value:number) {
        this._freespinsLeft = value;
    }

    get allWinPositions():boolean[][] {
        return this._allWinPositions;
    }

    get winRatio():number {
        return this._winRatio;
    }

    get xWayPositions():PIXI.Point[] {
        return this._xWayPositions;
    }

    get xWay():boolean {
        return this._xWay;
    }

    get evaluatedArea():string[][] {
        return this._evaluatedArea;
    }

    get currentMultiplier():number {
        return this._currentMultiplier;
    }

    get betClusterWins():IBetClusterWin[] {
        return this._betClusterWins;
    }

    get allWinClusters():PIXI.Point[][] {
        if(this._allWinPositions && this._allWinPositions.length > 0 && this._allWinClusters.length == 0) {
            this._allWinClusters = this.parseAllWinClusters(this._allWinPositions);
        }
        return this._allWinClusters;
    }

    get comboWinData():IComboWinData[] {
        return this._comboWinData;
    }

    get reels():string[][] {
        return this._reels;
    }

    get symbolYPositionsEvaluatedArea():number[][] {
        return this._symbolYPositionsEvaluatedArea;
    }

    get size4xWay():boolean {
        return this._size4xWay;
    }

    get bonusLevel():number {
        return this._bonusLevel;
    }

    get allSize():number[][] {
        return this._allSize;
    }

    get nextPlayerInteraction():any {
        return this._nextPlayerInteraction;
    }

    get enhancedBet():boolean {
        return this._enhancedBet;
    }

    get xWayTransformSymbol():string {
        return this._xWayTransformSymbol;
    }

    get brokeBank():boolean {
        return this._brokeBank;
    }

    get explodePositions():boolean[][] {
        return this._explodePositions;
    }

    get reelsEnteringFreespin():string[][] {
        return this._reelsEnteringFreespin;
    }

    get playedBetValue():number {
        return this._playedBetValue;
    }

    get thisSpinWinnings():number {
        return this._thisSpinWinnings;
    }
}